import { picklist, type InferInput } from "valibot";

export type CurrencyCode = InferInput<typeof CurrencyCode>;
export const CurrencyCode = picklist([
  "ARS",
  "AUD",
  "BRL",
  "CAD",
  "CLP",
  "CNY",
  "COP",
  "CZK",
  "DKK",
  "EUR",
  "HKD",
  "HUF",
  "INR",
  "IDR",
  "ILS",
  "JPY",
  "MYR",
  "MXN",
  "MAD",
  "NPR",
  "NZD",
  "TWD",
  "NOK",
  "PKR",
  "PHP",
  "PLN",
  "GBP",
  "RON",
  "RUB",
  "SAR",
  "RSD",
  "SGD",
  "ZAR",
  "KRW",
  "LKR",
  "SEK",
  "CHF",
  "THB",
  "TRY",
  "AED",
  "UAH",
  "USD",
]);
